import { useFormState } from "react-hook-form";

import { QuoteRequestLineFormData } from "#modules/quoteRequestLines/types/QuoteRequestLineFormData";

export const useProductLinesDirtyState = () => {
  const { dirtyFields } = useFormState<QuoteRequestLineFormData>({
    name: "productLines",
  });

  const isAnyProductDirty =
    Array.isArray(dirtyFields.productLines) &&
    dirtyFields.productLines.some(
      (product) => product?.quantity || product?.name || product?.price || product?.fixedPrice,
    );

  return {
    isAnyProductDirty,
    dirtyFields,
  };
};
